module.exports = __webpack_public_path__ + "img/locking_illustration_step_2.fd413c2.png";